/**
 * Campos customizados por empresa (roadmap #24).
 * A definição mora em companies/{id}/config/campos; o valor preenchido mora
 * no próprio lead, em `custom.{chave}`. Sem código novo para cada campo.
 */

export const TIPOS = [
  { key: 'texto',   label: 'Texto' },
  { key: 'numero',  label: 'Número' },
  { key: 'moeda',   label: 'Valor em R$' },
  { key: 'data',    label: 'Data' },
  { key: 'selecao', label: 'Lista de opções' },
  { key: 'simnao',  label: 'Sim / Não' },
  { key: 'url',     label: 'Link' },
];

/** Rótulo → chave estável: sem acento, sem espaço, sem colidir com o que já existe. */
export function chaveDe(label, existentes = []) {
  const base = String(label || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40) || 'campo';
  if (!existentes.includes(base)) return base;
  let n = 2; while (existentes.includes(`${base}_${n}`)) n++;
  return `${base}_${n}`;
}

/** Diz por que a definição é inválida, ou null se estiver ok. */
export function validarCampo(campo, outros = []) {
  if (!campo?.label?.trim()) return 'Dê um nome ao campo.';
  if (!TIPOS.some(t => t.key === campo.tipo)) return 'Escolha o tipo do campo.';
  if (campo.tipo === 'selecao' && !(campo.opcoes || []).filter(o => String(o).trim()).length) return 'Uma lista precisa de pelo menos uma opção.';
  if (outros.some(o => o.key !== campo.key && o.label.trim().toLowerCase() === campo.label.trim().toLowerCase())) return 'Já existe um campo com esse nome.';
  return null;
}

/** Texto digitado → valor gravado. Vazio vira null, para o campo sumir do lead. */
export function valorParaGravar(campo, bruto) {
  if (campo.tipo === 'simnao') return bruto === true || bruto === 'true' ? true : (bruto === false || bruto === 'false' ? false : null);
  const s = typeof bruto === 'string' ? bruto.trim() : bruto;
  if (s === '' || s === null || s === undefined) return null;
  if (campo.tipo === 'numero' || campo.tipo === 'moeda') { const n = Number(String(s).replace(/\./g, '').replace(',', '.')); return isNaN(n) ? null : n; }
  if (campo.tipo === 'selecao') return (campo.opcoes || []).includes(s) ? s : null;
  return String(s);
}

/** Valor gravado → texto de leitura. */
export function valorParaMostrar(campo, valor) {
  if (valor === null || valor === undefined || valor === '') return '';
  if (campo.tipo === 'simnao') return valor ? 'Sim' : 'Não';
  if (campo.tipo === 'moeda')  return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  if (campo.tipo === 'numero') return Number(valor).toLocaleString('pt-BR');
  if (campo.tipo === 'data')   return new Date(String(valor) + 'T00:00:00').toLocaleDateString('pt-BR');
  return String(valor);
}

/** Só os campos que o lead realmente preencheu, para exibição. */
export function preenchidos(campos, lead) {
  return (campos || [])
    .map(c => ({ campo: c, valor: lead?.custom?.[c.key] }))
    .filter(x => x.valor !== null && x.valor !== undefined && x.valor !== '');
}

/** Colunas extras para a exportação. */
export function colunasCustom(campos, lead) {
  const linha = {};
  for (const c of campos || []) linha[c.label] = valorParaMostrar(c, lead?.custom?.[c.key]);
  return linha;
}
